const API_ID = 12349;
const SCRIPT_URL = 'https://clippingmagic.com/api/v1/ClippingMagic.js';

export const initializeSDK = (apiId = API_ID) => {
  window.ClippingMagic.initialize({ apiId });
};

export function editBackground (id, secret) {
  const callbackHandler = (resolve, reject) => data => {
    if (['result-generated', 'editor-exit'].includes(data.event)) {
      return resolve(data.event);
    }

    return reject(data.event, data);
  };

  return new Promise((resolve, reject) => {
    window.ClippingMagic.edit({
      image: {
        id,
        secret
      },
      useStickySettings: true,
      locale: INKIVE.TranslateHelper.locale || 'en-AU'
    }, callbackHandler(resolve, reject));
  });
}

export function isClippingMagicLoaded () {
  return window.ClippingMagic && window.ClippingMagic.initialize;
}

export function initialize () {
  if (isClippingMagicLoaded()) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.id = 'script-clipping-magic';
    script.onload = () => initializeSDK() && resolve();

    document.body.appendChild(script);
  });
}
